/**
 * Join name parts into a full name string, filtering out empty/null/undefined values.
 *
 * @param parts - Array of name parts or object with name properties
 * @param separator - String to use between name parts (default: ' ')
 *
 * @example
 * joinNameParts(['John', 'Doe']) // 'John Doe'
 * joinNameParts(['John', '', 'Doe']) // 'John Doe'
 * joinNameParts(['John', null, 'Doe']) // 'John Doe'
 * joinNameParts({ firstName: 'John', lastName: 'Doe' }) // 'John Doe'
 * joinNameParts({ firstName: 'John', middleName: 'Michael', lastName: 'Doe' }) // 'John Michael Doe'
 * joinNameParts(['John', 'Doe'], '-') // 'John-Doe'
 */
export function joinNameParts(
  parts: (string | null | undefined)[] | Record<string, string | null | undefined>,
  separator = ' ',
): string {
  const nameParts = Array.isArray(parts) ? parts : Object.values(parts)

  return nameParts
    .filter((part): part is string => Boolean(part?.trim()))
    .join(separator)
    .trim()
}
